function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "success-standard-line");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "miter",
  strokeLinecap: "butt",
  strokeMiterlimit: 4,
  strokeWidth: 1.0909,
  stroke: "#000",
  fill: "#000",
  d: "M16 0.545c-8.535 0-15.455 6.919-15.455 15.455s6.919 15.455 15.455 15.455c8.535 0 15.455-6.919 15.455-15.455v0c0-8.535-6.919-15.455-15.455-15.455v0zM16 29.523c-7.468 0-13.523-6.054-13.523-13.523s6.054-13.523 13.523-13.523c7.468 0 13.523 6.054 13.523 13.523v0c0 7.468-6.054 13.523-13.523 13.523v0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "miter",
  strokeLinecap: "butt",
  strokeMiterlimit: 4,
  strokeWidth: 1.0909,
  stroke: "#000",
  fill: "#000",
  d: "M25.659 10.301c-0.175-0.174-0.416-0.282-0.682-0.282s-0.507 0.108-0.682 0.282l-10.72 10.673-5.795-5.795c-0.177-0.176-0.422-0.285-0.692-0.285-0.542 0-0.982 0.44-0.982 0.982 0 0.243 0.089 0.466 0.235 0.638l-0.001-0.001 7.235 7.215 12.084-12.054c0.177-0.175 0.286-0.418 0.286-0.686s-0.109-0.511-0.286-0.686l-0-0z"
});

var SvgSuccessCircle = function SvgSuccessCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success-circle.6ac1a997.svg";
export { ForwardRef as ReactComponent };